import Dot from 'components/Dot';
import HmsEntityTableController from 'components/HmsEntityTableController';
import useEntities from 'hooks/useEntities';
import useFetchEntities from 'hooks/useFetchEntities';
import useIsMobile from 'hooks/useIsMobile';
import useOrganization from 'hooks/useOrganization';

const Players = () => {
    const entities = useEntities();
    const isMobile = useIsMobile();
    const { organization } = useOrganization();
    const ORGANIZATION_ID = organization?.organizationId;

    const { data: players } = useFetchEntities('Player', { onlyAttributes: 'playerId', extraAttributes: 'NewChangeRequestCount', filters: { 'HasNewChangeRequest': 1 } });
    const hasWithChangeRequests = players?.length > 0;

    return (
      <>
        <HmsEntityTableController
          entity={entities.Player}
          columnSets={[
            {
              name: 'Active + Invited',
              filters: { status: ['ACTIVE', 'INVITED'] },
              columns: [
                { column: 'NameWithLogo', width: 200, fixed: !isMobile ? 'left' : undefined, },
                { column: 'LevelTag', },
                { column: 'Teams', width: 250, },
                { column: 'Positions', width: 125, },
                { column: 'Jerseys', width: 125, },
                'status',
                'User',
                'birthday',
                'phone',
                'email',
                'gender',
                'stick',
                'weight',
                'height',
                'externalId',
                'countryBirth',
                'cityBirth',
                'country',
                'city',
              ],
            },
            {
              name: 'Not active',
              filters: { status: ['INACTIVE', 'RETIRED', 'UNKNOWN'] },
              columns: [
                { column: 'NameWithLogo', width: 200, fixed: !isMobile ? 'left' : undefined, },
                { column: 'LevelTag', },
                { column: 'Teams', width: 250, },
                { column: 'Positions', width: 125, },
                { column: 'Jerseys', width: 125, },
                'status',
                'User',
                'birthday',
                'phone',
                'email',
                'gender',
                'stick',
                'weight',
                'height',
                'externalId',
                'countryBirth',
                'cityBirth',
                'country',
                'city',
              ],
            },
            {
              name: 'Newly Registered',
              // HMS-76: s povinnym schvalovanim patri do fronty i pozvani hraci (INVITED), kteri jeste nebyli schvaleni
              filters: { status: organization?.playerApprovalRequired ? ['DRAFT', 'PREAPPROVED', 'INVITED'] : ['DRAFT', 'PREAPPROVED'] },
              columns: [
                'createdAt',
                { column: 'NameWithLogo', width: 200 },
                { column: 'Teams', width: 250, },
                { column: 'RegistrationExistingTeam', width: 250, },
                { column: 'Level', width: 175, },
                { column: 'Positions', width: 125, },
                { column: 'Jerseys', width: 125, },
                'status',
                'User',
                'birthday',
                { column: 'phone', width: 175, },
                { column: 'email', width: 250, },
                'gender',
                'stick',
                'weight',
                'height',
                'countryBirth',
                'cityBirth',
              ],
            },
            {
              name: <Dot show={hasWithChangeRequests} dotClassName="top-[-6px] right-[-10px]">Change Requests</Dot>,
              key: 'ChangeRequests',
              shitFilter: (r) => r.NewChangeRequestCount > 0,
              columns: [
                'createdAt',
                { column: 'NameWithLogo', width: 200 },
                { column: 'Teams', width: 250, },
                { column: 'RegistrationExistingTeam', width: 250, },
                { column: 'Level', width: 175, },
                { column: 'Positions', width: 125, },
                { column: 'Jerseys', width: 125, },
                'status',
                'birthday',
                { column: 'phone', width: 175, },
                { column: 'email', width: 250, },
                'gender',
                'stick',
                'weight',
                'height',
                'countryBirth',
                'cityBirth',
                'NewChangeRequestCount',
              ],
            },
          ]}
        />
      </>
    )
}

export default Players